import * as yup from "yup";
import { emailReg } from "../utils/functions";

export const create_account_schema = {
    entity_type: null,
    email: "",
    country: null,
    phone_number: "",
    unified_number: "",
    cr_expiry: null,
    is_terms_accepted: false,
};

export const create_account_validation_schema = yup.object().shape({
    entity_type: yup.object(),
    email: yup
        .string()
        .required("email_required")
        .matches(emailReg, "invalid_email"),
    country: yup
        .object(),
    phone_number: yup
        .string()
        .required("phone_number_required"),
    unified_number: yup
        .string()
        .min(9, "unified_number_min_length")
        .max(12, "unified_number_max_length"),
    cr_expiry: yup
        .date()
        .nullable(),
    is_terms_accepted: yup
        .boolean()
        .oneOf([true], "terms_must_be_accepted")
});
